class CharacterPower {
	constructor(title, description) {
		this.title = title;
		this.description = description;
	}

	toPlainObj() {
		return {
			title: this.title,
			description: this.description
		};
	}
}

export default function CharacterPowerBuilder() {
	return {
		withTitle: function (title) {
			this.title = title;
			return this;
		},
		withDescription: function (description) {
			this.description = description;
			return this;
		},
		build: function () {
			return new CharacterPower(this.title, this.description);
		}
	};
}
